import ContentCard from "@components/ui/ContentCard";
import "./AboutPage.css";

/**
 * About page component displaying information about SKEMA Business School and ISCRI development
 * @returns {JSX.Element}
 */
const AboutPage = () => {
  return (
    <div className="about-page">
      <section className="hero-about">
        <div className="container hero-about-content">
          <h1 className="page-title">About ISCRI</h1>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="creative-layout">
            <ContentCard icon="🌍" title="SKEMA Business School" animationDelay={0.1}>
              <p className="content-card__text">
                SKEMA Business School is a global school that prepares the
                business talents of the 21st century -
                <span className="highlight-text"> responsible</span>,
                <span className="highlight-text"> mobile</span>,
                <span className="highlight-text"> multicultural</span>,
                entrepreneurs with abilities to manage information, data and
                knowledge.
              </p>
            </ContentCard>

            <ContentCard icon="🤝" title="ISCRI Development" animationDelay={0.2}>
              <p className="content-card__text">
                The ISCRI has been developed by{" "}
                <strong>SKEMA Centre for Global Risks</strong>, in partnership
                with:
              </p>
              <ul className="content-card__list content-card__list--arrow">
                <li>SKEMA School of Geopolitics for Business</li>
                <li>SKEMA Artificial Intelligence Innovation Centre</li>
                <li>SKEMA Publika</li>
              </ul>
            </ContentCard>

            <ContentCard icon="🔬" title="Research Excellence" animationDelay={0.3}>
              <p className="content-card__text">
                SKEMA's commitment to research excellence drives the
                development of innovative tools like ISCRI, which bridge
                academic rigor with practical applications for business and
                policy-making in an increasingly interconnected world.
              </p>
            </ContentCard>

            <ContentCard icon="📊" title="Global Impact" animationDelay={0.4}>
              <p className="content-card__text">
                By providing real-time insights into interstate conflictual
                relations, ISCRI serves stakeholders worldwide in
                understanding geopolitical tensions that can influence trade
                flows, capital movements, and global economic stability.
              </p>
            </ContentCard>

            <ContentCard
              icon="✉️"
              title="Contact & Feedback"
              animationDelay={0.5}
              actionLabel="rodolphe.desbordes@skema.edu"
              actionHref="mailto:rodolphe.desbordes@skema.edu"
            >
              <p className="content-card__text">
                Please send an email to <strong>Rodolphe Desbordes</strong>{" "}
                for further information, comments, and feedback.
              </p>
            </ContentCard>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
